import { createContext, useContext, useState, useEffect } from 'react';
import { client } from '../sanityClient';

const SiteSettingsContext = createContext(undefined);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let active = true;
    client
      .fetch('*[_type == "siteSettings"][0]')
      .then((data) => {
        if (active) {
          setSettings(data);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.error(err);
        if (active) setIsLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <SiteSettingsContext.Provider value={{ settings, isLoading }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

/**
 * Custom hook to consume site settings from context.
 * Must be used inside a <SiteSettingsProvider>.
 */
export function useSiteSettings() {
  const ctx = useContext(SiteSettingsContext);
  if (ctx === undefined) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return ctx;
}
